import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { hashData } from '../search-result-utils';
var CONFLUENCE_VALUE_SEPARATOR = '---';
var CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';

/**
 * Returns a URL with Confluence specific analytics query parameters. The
 * additionalAnalytics will be formatted as a single string and assigned to
 * the additional_analytics query parameter. This string will have the
 * following format:
 * <queryHash>---<value>___<key>---<value>___<key>---<value>
 */
export var getConfluenceUrlWithAnalyticsQueryParams = function getConfluenceUrlWithAnalyticsQueryParams(_ref) {
  var url = _ref.url,
    query = _ref.query,
    searchSessionId = _ref.searchSessionId,
    additionalAnalytics = _ref.additionalAnalytics;
  var urlObject = new URL(url);
  urlObject.searchParams.set('search_id', searchSessionId);
  var events = [];
  if (query) {
    events.push("queryHash".concat(CONFLUENCE_VALUE_SEPARATOR).concat(hashData(query)));
  }
  if (additionalAnalytics) {
    Object.entries(additionalAnalytics).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        attribute = _ref3[0],
        value = _ref3[1];
      events.push("".concat(attribute).concat(CONFLUENCE_VALUE_SEPARATOR).concat(value));
    });
  }
  if (events.length === 0) {
    return urlObject.toString();
  }
  var analyticsFormattedForUrlParsing = encodeURIComponent(events.join(CONFLUENCE_ATTRIBUTE_SEPARATOR));
  urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
  return urlObject.toString();
};

/**
 * Parses strings with the following format into an object:
 * <key>---<value>___<key>---<value>
 */
export var parseConfluenceAdditionalAnalyticsQueryParam = function parseConfluenceAdditionalAnalyticsQueryParam(additionalAnalytics) {
  var formattedEvents = {};
  if (typeof additionalAnalytics !== 'string') {
    return formattedEvents;
  }
  var events = additionalAnalytics === null || additionalAnalytics === void 0 ? void 0 : additionalAnalytics.split(CONFLUENCE_ATTRIBUTE_SEPARATOR);
  events.forEach(function (event) {
    var formattedEvent = event === null || event === void 0 ? void 0 : event.split(CONFLUENCE_VALUE_SEPARATOR);
    var hasProperlyFormattedEvent = formattedEvent.length === 2;
    if (hasProperlyFormattedEvent) {
      formattedEvents[formattedEvent[0]] = formattedEvent[1];
    }
  });
  return formattedEvents;
};

/**
 * Returns a URL with Jira specific analytics query parameters. The resultId
 * and projectId must be ARIs.
 */
export var getJiraUrlWithAnalyticsQueryParams = function getJiraUrlWithAnalyticsQueryParams(_ref4) {
  var url = _ref4.url,
    searchSessionId = _ref4.searchSessionId,
    resultId = _ref4.resultId,
    projectId = _ref4.projectId;
  var jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
  if (!resultId.match(jiraResultARIPattern)) {
    return url;
  }
  var jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
  if (projectId && !projectId.match(jiraProjectARIPattern)) {
    return url;
  }
  var urlObject = new URL(url);
  urlObject.searchParams.set('searchSessionId', searchSessionId);
  var searchObjectId = resultId.split('/').pop();
  searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
  var searchContentType = resultId.split('/')[0].split(':').pop();
  searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
  var searchContainerId = projectId === null || projectId === void 0 ? void 0 : projectId.split('/').pop();
  searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
  return urlObject.toString();
};
export var getGenericUrlWithAnalyticsQueryParams = function getGenericUrlWithAnalyticsQueryParams(_ref5) {
  var url = _ref5.url,
    searchSessionId = _ref5.searchSessionId;
  var urlObject = new URL(url);
  urlObject.searchParams.set('search_id', searchSessionId);
  return urlObject.toString();
};